import { render } from "./FattureContainer.vue?vue&type=template&id=eedbbe88"
import script from "./FattureContainer.vue?vue&type=script&lang=js"
export * from "./FattureContainer.vue?vue&type=script&lang=js"

import "./FattureContainer.vue?vue&type=style&index=0&id=eedbbe88&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__